export const RANGO_DOCS_URL = 'https://docs.rango.exchange/';
export const RANGO_WEBSITE_URL = 'https://rango.exchange/';
